import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const services = [{
  title: "Totholzentfernung",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/totholzentfernung_hamburg_service.png",
  link: "/CareAndPruningPage"
}, {
  title: "Kronenpflege",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/kronenpflege_baumpflege_straesser.png",
  link: "/CareAndPruningPage"
}, {
  title: "Baumfällung",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/baumfaellung_sicherheitsfällung.png",
  link: "/FellingAndRootsPage"
}];
export default function OurSignatureCreations() {
  return;
}